import React from "react";

import { Row, Col, Img, Text } from "../../comps";
import { Theme } from "../../theme/theme-provider";

import { SERVER_BASE_URL } from "../../config";
import { spotifyLogo } from "../../theme/image";

const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;

export default ({ connected, username }) => {
  const handleSpotifyAuth = () => {
    return `https://accounts.spotify.com/authorize?client_id=${CLIENT_ID}&redirect_uri=${SERVER_BASE_URL}/spotify/auth&response_type=code&state=${username}`;
  };

  return (
    <Row
      style={{
        width: "100%",
        height: "20%",
        alignItems: "center",
      }}
    >
      <Img height="40%" src={spotifyLogo} />
      <Col>
        <Row alignItems="center">
          <Text
            fontSize="22px"
            color={Theme.color.GRAY_1}
            fontFamily={Theme.fontFamily.recursive}
            fontWeight="600"
          >{`Spotify : `}</Text>
          <Text
            fontSize="18px"
            color={Theme.color.GRAY_0}
            fontFamily={Theme.fontFamily.recursive}
            fontWeight="600"
          >
            {connected ? "connected" : "not connected"}
          </Text>
        </Row>
        <a href={handleSpotifyAuth()} target="_blank" style={{color:Theme.color.GRAY_0}}>
          {connected ? `reconnect spotify` : `connect spotify`}
        </a>
      </Col>
    </Row>
  );
};
